import { VideoBlock } from '../video.block'

export const YouTubeVideo = (block: VideoBlock) => {
  return (
    <iframe
      width="100%"
      height="100%"
      src={`https://www.youtube.com/embed/${block.videoId}`}
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowFullScreen
      title="Embedded youtube"
      loading="lazy"
      style={{
        aspectRatio: '16 / 9',
        borderRadius: '10px',
      }}
    />
  )
}
